import Vue from 'vue';
import VueRouter from 'vue-router';
import store from './store';

Vue.use(VueRouter);

/* Auto load all route files */
let routes = [];
const rfiles = require.context('./routes', true, /\.js$/i);
rfiles.keys().forEach((key) => {
    const obj = rfiles(key).default;
    if(obj && obj.routes) {
        routes = routes.concat(obj.routes);
    }
});

const router = new VueRouter({
    mode: 'history',
    routes: routes
});

router.beforeEach(async (to, from, next) => {
    if(to.name === 'index') {
        store.state.pageTitle = to.meta.name;
        await next();
        return;
    }
    if(to.meta.permissions) {
        store.state.loading++;
        let refresh = null;
        try {
            refresh = await router.app.$get('/json/user');
        } catch(e) {}
        store.state.loading--;
        if(!refresh || !refresh.permissions) {
            store.state.user = new User(null);
            await next('/');
            return;
        }
        store.state.user.permissions_flat = refresh.permissions;
        if(!store.state.user.canAny(to.meta.permissions)) {
            await next(to.meta.redirect || '/');
            return;
        }
    }
    store.state.pageTitle = to.meta.name;
    await next();
});

export default router; 